import React, { useMemo } from 'react';
import styles from './feed.module.scss';
import { KoStaicMembers, KoTitle } from 'packages';
import { useSelector } from 'react-redux';

function mapUsers(users) {
  return users?.map((u) => ({
    id: u.userId,
    name: `${u.profile.firstName} ${u.profile.lastName}`,
    logo: u.profile.logo,
    email: u.email,
    firstName: u.profile.firstName,
    lastName: u.profile.lastName,
    days: {}
  }));
}
export default function Trending() {
  const users = useSelector(state => state.users);

  const team = useMemo(() => {
    const mapped = users['data'] && mapUsers(users['data']);
    mapped.forEach((m) => {
    });
    return mapped;
  }, [users]);

  return (
    <div className={`${styles.wrapperTrendingMain}`}>
      <div className={styles.trendingHeader}>
        <KoTitle level={4} text="My Team" className={styles.trendingTitle} />
        <div className={styles.trendingMembers}>
          {
            team?.map((item, i) =>
              <KoStaicMembers data={item} key={i} />
            )
          }
        </div>
      </div>
    </div>
  );
}
